import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    IconButton,
    TableFooter,
    Box
} from '@mui/material';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { Grey3 } from '../../../../color_utils';
import { trakrefFontFamily } from '../../../../utils';
import RowTable from './Row';
import useEmailAlert from '../context/useEmailAlert';
import { getDefaultSortBy } from '../../../Common/Table/utils';
import UserInfo from '../../../../UserInfo';

const EMAIL_ALERT_SESS_KEY = `emailAlertTable-url-${UserInfo.instanceId}`;

const EmailAlertTable = () => {

    const { tableData: data } = useEmailAlert();

    const cellTextStyle = {
        color: Grey3,
        fontFamily: trakrefFontFamily,
        fontSize: "10px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "normal",
        letterSpacing: "1.429px",
        textTransform: "uppercase",
        cursor: "pointer"
    };

    const [pageData, setPageData] = useState([])
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [sortBy, setSortBy] = useState(sessionStorage.getItem(EMAIL_ALERT_SESS_KEY));

    const onPageChange = (type) => {
        let currentPage = page;

        if (type === 'back') {
            currentPage = currentPage - 1;
            setPageCount(prev => ({
                min: ((prev.max - data[page].length) - data[currentPage].length) + 1,
                max: prev.max - data[page].length
            }))
            setPage(currentPage);
        } else {
            currentPage = currentPage + 1;
            setPageCount(prev => ({
                min: prev.max + 1,
                max: prev.max + data[currentPage].length
            }))
            setPage(currentPage);
        }


        setPageData(data[currentPage]);
    }

    useEffect(() => {
        setTotalCount(data.flat().length);
        setPageData(data[0]);
        if (page === 0) {
            setPageCount({
                min: 1,
                max: data[0].length
            });
        }
    }, [data])

    const onSorting = () => {
        const newSorting = !sortBy || sortBy === "" ? "desc" : (
            sortBy === "desc" ? "asc" : "desc"
        );
        const newPageData = [...pageData].sort((a, b) =>
            newSorting === "desc"
                ? b.emailAddress.localeCompare(a.emailAddress)
                : a.emailAddress.localeCompare(b.emailAddress)
        );

        setPageData([...newPageData]);
        setSortBy(newSorting);

        sessionStorage.setItem(EMAIL_ALERT_SESS_KEY, newSorting);
    }

    return (
        <>
            <div style={{
                marginBottom: 10,
                borderRadius: "3.52px",
                border: " 0.88px solid #EBEDF8",
                background: "#FFF"
            }}>
                <Table aria-label="collapsible table" size='small'>
                    <TableHead style={{ height: "60px" }}>
                        <TableRow>
                            <TableCell style={cellTextStyle} onClick={onSorting}>
                                <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "5px"
                                }}>
                                    Email Address
                                    <Box sx={{ width: "10px" }}>
                                        {sortBy === "asc" && (
                                            <ExpandMoreIcon ExpandMoreIcon className='sortIcon' />
                                        )}
                                        {sortBy === "desc" && (
                                            <ExpandLessIcon className='sortIcon' />
                                        )}
                                    </Box>
                                </div>
                            </TableCell>
                            <TableCell style={cellTextStyle}>Alerts</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            pageData.map(x => {
                                return <RowTable rowData={x} />
                            })
                        }
                    </TableBody>
                </Table>
                <TableFooter sx={{
                    "&.MuiTableFooter-root": {
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        borderTop: '0.5px solid rgba(216, 216, 216, 0.15)'
                    }
                }}>
                    <div style={{
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: "60px",
                        margin: "auto",
                        padding: "20px"
                    }}>
                        <IconButton size='small' disabled={page - 1 < 0} onClick={() => onPageChange('back')}>
                            <ArrowBackIosOutlinedIcon sx={{ "&.MuiSvgIcon-root": { fontSize: "14px", color: "#000000" } }} />
                        </IconButton>
                        <span style={{
                            color: "#000",
                            textAlign: "center",
                            fontFamily: trakrefFontFamily,
                            fontSize: "10.56px",
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "normal"
                        }}>{pageCount.min}-{pageCount.max} of {totalCount}</span>
                        <IconButton size='small' disabled={(totalCount === pageCount.max)} onClick={() => onPageChange('next')}>
                            <ArrowForwardIosOutlinedIcon sx={{ "&.MuiSvgIcon-root": { fontSize: "14px", color: "#000000" } }} />
                        </IconButton>
                    </div>
                </TableFooter>
            </div >
        </>
    )
}

export default EmailAlertTable;